import { useEffect, useState } from "react";
import { getCompanyToday } from "./jobOverlapsRange";

export const useCompanySelectedDate = (companyId: string | number | null | undefined, timeZone: string) => {
  const [selectedDate, setSelectedDate] = useState(() => getCompanyToday(timeZone));

  useEffect(() => {
    setSelectedDate(getCompanyToday(timeZone));
  }, [companyId, timeZone]);

  return [selectedDate, setSelectedDate] as const;
};
